export default "__VITE_ASSET__C4minY4q__"